export function formatCalendarDay(value = new Date()) {
  if (value == null || value === "") return "";
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}/.test(value)) {
    return value.slice(0, 10);
  }
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function addCalendarDays(value, days) {
  const d = value instanceof Date ? new Date(value) : new Date(value || Date.now());
  if (Number.isNaN(d.getTime())) return "";
  d.setDate(d.getDate() + Number(days || 0));
  return formatCalendarDay(d);
}

export function monthKeyFromDate(value = new Date()) {
  const day = formatCalendarDay(value);
  return day ? day.slice(0, 7) : "";
}

export function indexAgendaDays(days) {
  const map = {};
  for (const day of days || []) {
    if (!day?.date) continue;
    map[day.date] = day;
  }
  return map;
}

/** Group nights vs player-owned bookings, matching the backend month agenda. */
export function foldSessionMonthAgenda(rows) {
  const byDate = new Map();
  for (const row of rows || []) {
    const date = formatCalendarDay(row?.ts_date);
    if (!date) continue;
    const kind = row?.ts_owner_player_id ? "private" : "group";
    let entry = byDate.get(date);
    if (!entry) {
      entry = { date, kinds: [], group_count: 0, private_count: 0 };
      byDate.set(date, entry);
    }
    if (kind === "private") entry.private_count += 1;
    else entry.group_count += 1;
    if (!entry.kinds.includes(kind)) entry.kinds.push(kind);
  }
  return [...byDate.values()].sort((a, b) => a.date.localeCompare(b.date));
}
